<template>
  <mt-tabbar class="my-tabbar" v-model="selected">
    <mt-tab-item :id="item.name" v-for="(item, tindex) in tabbar" :key="tindex">
      <img
        slot="icon"
        :src="
          `${tindex == index ? item.icon + '_active' : item.icon}.png`
            | mobileImagePath
        "
      />
      {{ item.name }}
      <mt-badge
        class="my-tabbar-badge"
        size="small"
        type="error"
        v-if="item.badge"
        >{{ item.badge }}</mt-badge
      >
    </mt-tab-item>
  </mt-tabbar>
</template>

<script>
import { Tabbar, TabItem } from "mint-ui";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "MyTabbar",
  components: { Tabbar, TabItem },
  data() {
    return {
      tabbar: [
        {
          name: "首页",
          icon: "home",
          badge: 0,
        },
        {
          name: "分类",
          icon: "category",
          badge: 0,
        },
        {
          name: "购物车",
          icon: "cart",
          badge: 0,
        },
        {
          name: "我的",
          icon: "mine",
          badge: 0,
        },
      ],
      selected: "",
    };
  },
  props: {
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters("user", ["isLogin"]),
  },
  methods: {},
  created() {
    const { tabbar, index } = this;
    this.selected = index < 0 ? "" : tabbar[index].name;
  },
  mounted() {},
  watch: {
    selected(nVal, oldVal) {
      const { tabbar, isLogin } = this;
      const index = tabbar.findIndex((item) => item.name == nVal) || 0;
      if (isLogin || (!isLogin && index < 2)) {
        this.$emit("update:index", index);
      } else {
        this.$router.push("mlogin"); //购物车和我的，强制登录
      }
    },
  },
};
</script>

<style>
.mint-tab-item.is-selected .mint-tab-item-label {
  color: #f00;
}
.my-tabbar .mint-tab-item {
  position: relative;
}
.my-tabbar-badge {
  position: absolute;
  right: 0.4rem;
  top: 0.08rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/mobile/components/MyTabbar/index.vue